<script>
import baseMixin from '@mixins/baseMixin.js'

export default {
  name: 'MessageBubbleSkeleton',
  mixins: [baseMixin],
  props: {
    sent: {
      type: Boolean,
    },
    loaderType: {
      type: String,
      default: 'paragraph',
    },
  },
}
</script>

<template>
  <div :class="['message', sent ? 'send' : 'receive']">
    <div class="message-bubble-content" style=" width: 200px;">
      <v-skeleton-loader :type="`${loaderType}`"></v-skeleton-loader>
    </div>
  </div>
</template>
